import { call, put, takeEvery } from "redux-saga/effects";
import Api_Instance from "../api/Api_Instance";
import { endpoints } from "../api/endpoints";
import { setBanner } from "./slice/Slice";

const api = Api_Instance.unAuth();
const getData = async () => {
    let response = await api("GET", endpoints.BUSSINESS_API, null, { category: 102 });
    return await response;
};


function* fetchData() {
    try {
        let data = yield call(getData);
        yield put(setBanner(data?.data?.data));
    } catch (error) {
        yield put({ type: "user/setError" });
    }
}

function* rootSaga() {
    yield takeEvery("FETCH", fetchData);
}

export default rootSaga;
